// /api/snapshot exposes `ems_action_engagement` als string. Mapping naar
// Nederlandse subline-tekst voor Strategie-tegel. Pure functie, geen state.
//
// Onbekende engagement-waarden vallen terug op de raw string (zichtbaar voor
// debugging, geen NaN). undefined/empty → null = ControlTile rendert geen
// subline.

export function engagementToSubline(engagement: string | undefined | null): string | null {
  if (!engagement) return null;
  switch (engagement) {
    case 'yield':      return 'Yield — PV vult batt zelf';
    case 'feedin':     return 'Feed-in — accu vast, PV naar net';
    case 'charge':     return 'Laden naar batterij';
    case 'discharge':  return 'Ontladen naar grid';
    case 'idle':       return 'Idle — geen actie nu';
    case 'peak_shave': return 'Peak-shaving actief';
    default:           return engagement;
  }
}
